module.exports = __webpack_public_path__ + "static/line1_7-60682bb9ca469e1046495316f481f502.jpg";